module.exports = __webpack_public_path__ + "img/copyrights.d1acf9f1.svg";